import type { PropsWithChildren } from 'react'
import styled from 'styled-components'

import HorizontalContainerWithFadedOverflow from 'components/Common/HorizontalContainerWithFadedOverflow'
import Group from 'components/utils/Group'

const StyledGroup = styled(Group)`
  @media print {
    display: none;
  }
`

function FilterChipsScrollContainer({ children }: PropsWithChildren<{ }>) {
  return (
    <HorizontalContainerWithFadedOverflow>
      <StyledGroup gap={8} horizontalAlign="start" direction="horizontal">
        {children}
      </StyledGroup>
    </HorizontalContainerWithFadedOverflow>
  )
}

export default FilterChipsScrollContainer
